<template>
	<div v-if="getAuthenticatedUserGroupLevel === '5' || getAuthenticatedUserGroupLevel === '6'">
		<BaseHeader :title="$t('save_new_rental_car').toString()" />
		<RentalCarForm />
	</div>
	<Forbidden v-else />
</template>

<script>
import RentalCarForm from '@/components/rentalcars/forms/RentalCarForm';
import BaseHeader from '@/components/navigation/BaseHeader';
import Forbidden from '@/views/default/Forbidden.vue';
export default {
	name: 'RentalCarNew',
	components: { Forbidden, BaseHeader, RentalCarForm },
	computed: {
		getAuthenticatedUserGroupLevel() {
			return this.$store.getters.getAuthenticatedUserGroupLevel;
		},
	},
};
</script>

<style scoped></style>
